module.exports = __webpack_public_path__ + "bb7abacf68af7e07d67ccb5239569e09.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/ubs_asset_management.png
// module id = 1872
// module chunks = 0